export default __webpack_public_path__ + "static/media/package-xls-icon.49ad7d2f.svg";